<template>
  <div>
    <div v-if="qrUrl" style="margin: 8% 10%;">
      <h2 style="margin-top: 5%; display: flex; justify-content: center; color: #333;">请扫码继续操作</h2>
      <qr-code :text="qrUrl" style="margin-top: 5%; display: flex; justify-content: center;"></qr-code>
    </div>
    <div v-if="isMicroMessenger" style="background-color: rgba(0, 0, 0, 0.8); width: 100vw; height: 120vh;">
      <img src="https://www.zerofast.net/assets/images/4330982145d01d69a77407.jpeg" style="width: 100%;"/>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
import { setToken, setAppType } from '@/libs/util'
import { Base64 } from 'js-base64'
var md5 = require('js-md5')

export default {
  name: 'inAppSSO',
  components: {
    'qr-code': VueQRCodeComponent
  },
  data () {
    return {
      qrUrl: '',
      device: '',
      appType: '',
      token: '',
      nonce: '',
      sign: '',
      url: '',
      page: '',
      isMicroMessenger: false
    }
  },
  methods: {
    initQuery () {
      if (typeof this.$route.query.token === 'undefined') {
        return false
      }
      if (typeof this.$route.query.sign === 'undefined') {
        return false
      }
      if (typeof this.$route.query.nonce === 'undefined') {
        return false
      }
      this.token = this.$route.query.token
      this.nonce = this.$route.query.nonce
      this.sign = this.$route.query.sign
      this.url = this.$route.query.url || ''
      this.appType = this.$route.query.app_type || 'h5'
      this.device = this.$route.query.device || 'phone'
      this.page = this.$route.query.page || ''
      if (this.sign !== md5(Base64.encode(this.token) + this.nonce + 'zerofast')) {
        return false
      }
      setToken(this.token)
      setAppType(this.appType)
      if (this.device === 'tvbox') {
        this.qrUrl = location.href.replace('device=tvbox&', '')
        return false
      }
      this.isMicroMessenger = this.checkMicroMessenger()
      if (this.isMicroMessenger) {
        return false
      }
      if (this.url !== '') {
        location.href = Base64.decode(this.url)
      } else {
        if (this.page !== '') {
          this.redirectPage(this.page)
        } else {
          location.href = '/#/in-app/devices'
        }
      }
    },
    redirectPage (page) {
      if (page === 'member') {
        location.href = '/#/in-app/member'
      } else if (page === 'vod') {
        location.href = '/#/in-app/vod/home'
      }
    },
    checkMicroMessenger () {
      const re = /MicroMessenger/
      return re.test(navigator.userAgent)
    }
  },
  created () {
    this.$parent.isLoadUser = false
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    this.$parent.showSkeleton = false
    document.title = 'Zerofast'
  },
  mounted () {
    this.initQuery()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inApp/Sso.vue